import React from 'react';
import PropTypes from 'prop-types';
import { Route, Link, withRouter } from "react-router-dom";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import HelpIcon from '@material-ui/icons/Help'
import AwesomeDebouncePromise from 'awesome-debounce-promise'
import {isMobile} from 'react-device-detect'


class LectureResults extends React.Component {
  constructor(props){
    super(props)
    this.state = {
    }
  }

  componentDidMount (){
    const {params} = this.props.match ? this.props.match : false
    if (params && 'id' in params) this.setState({id : params.id})
    let s = this.props.socket
    s.on('lecture results', data => {
      this.setState({results : data})
    })
    s.emit('get lecture results',{id : params.id})
  }


  render () {
    return (<div></div>)
  }
}

export default withRouter(LectureResults)
